import { BrowserRouter as Router } from "react-router-dom";
import './styles/index.css';
import AppContent from './AppContent.js';

export default function App(){
  return(
    <>
      <div className="bgImage"></div>
      <div>
        <Router>
          <AppContent/>
        </Router>
      </div>
    </>
  );
}